import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

   /**
   * Aktiviert den Loading-Spinner.
   * Setzt den State auf true.
   */
  show() {
    this.loadingSubject.next(true);
  }

   /**
   * Deaktiviert den Loading-Spinner.
   * Setzt den State auf false.
   */
  hide() {
    this.loadingSubject.next(false);
  }
}
